import { useCallback } from 'react';
import useApplication, {
  ApplicationDetails
} from 'screens/Applications&WorkOrders/Applications/Hooks/useApplication';
import useQuery, { QueryKey } from 'hooks/useQuery';
import { CancelToken } from 'axios';

const useApplicationDetails = (applicationId: string | null) => {
  const { getApplication } = useApplication();

  const queryFn = useCallback(
    (id: QueryKey, cancelToken?: CancelToken) => {
      if (!id || typeof id !== 'string') {
        throw new Error('Application ID is required');
      }
      return getApplication(id, cancelToken);
    },
    [getApplication]
  );

  const { data, errors, isLoading, refreshCache, refetch } = useQuery<
    ApplicationDetails
  >(applicationId, queryFn, {
    cacheKeyPrefix: 'application',
    cacheTTL: 0 // No caching for application details
  });

  return {
    applicationDetails: data,
    errors,
    isLoading,
    refreshCache,
    refetch
  };
};

export default useApplicationDetails;
